import React, { useEffect, useState } from 'react';
import { Section } from '../ui/Section';
import { motion } from 'framer-motion';
import { CTAButton } from '../ui/CTAButton';
import { ShieldCheck, Download, Lock, Users, Leaf, Check } from 'lucide-react';
export function HeroSection() {
  const [count, setCount] = useState(2800);
  useEffect(() => {
    const interval = setInterval(() => {
      setCount(prev => prev < 2847 ? prev + 1 : prev);
    }, 50);
    return () => clearInterval(interval);
  }, []);
  const bullets = [{
    bold: 'Dosificado por tu peso exacto',
    text: '— no recetas genéricas que no funcionan'
  }, {
    bold: 'Ingredientes de tu mercado local',
    text: '— árnica, jengibre, boldo, cúrcuma'
  }, {
    bold: 'Rotación semanal',
    text: 'para que el cuerpo nunca pierda respuesta'
  }, {
    bold: 'Alivio visible en 24-48 horas',
    text: '— no semanas'
  }];
  return <div className="w-full bg-gradient-to-b from-[#FDF8F0] via-[#fffbf5] to-[#f4eadd] pt-5 pb-6 relative overflow-hidden" data-id="element-91">
      {/* Animated Background Pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" data-id="element-92">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(#2D5016_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-93"></div>
      </div>

      {/* Floating Elements */}
      <motion.div animate={{
      y: [0, -15, 0],
      rotate: [0, 5, 0]
    }} transition={{
      duration: 4,
      repeat: Infinity,
      ease: 'easeInOut'
    }} className="absolute top-10 left-5 md:left-20 opacity-20 pointer-events-none" data-id="element-94">
        <Leaf className="w-12 h-12 text-[#2D5016]" data-id="element-95" />
      </motion.div>
      <motion.div animate={{
      y: [0, 15, 0],
      rotate: [0, -5, 0]
    }} transition={{
      duration: 5,
      repeat: Infinity,
      ease: 'easeInOut',
      delay: 1
    }} className="absolute top-20 right-5 md:right-20 opacity-20 pointer-events-none" data-id="element-96">
        <Leaf className="w-16 h-16 text-[#D4A017]" data-id="element-97" />
      </motion.div>

      <Section className="text-center !py-2 relative z-10" data-id="element-98">
        {/* Layer 1: Pre-Headline */}
        <motion.p initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="text-[#C1440E] font-bold italic text-sm md:text-base mb-4 tracking-wide uppercase bg-[#C1440E]/10 inline-block px-4 py-1 rounded-full" data-id="element-99">
          Para hombres y mujeres mayores de 30 años que ya probaron de todo y
          siguen sufriendo...
        </motion.p>

        {/* Layer 2: Headline */}
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-extrabold text-[#2C1810] leading-tight mb-4 drop-shadow-sm" data-id="element-100">
          "Lo Que Tu Abuela Sabía Y La Farmacia Te Cobró Ignorar: 40+ Recetas
          Con Ingredientes De Tu Mercado Que Eliminan Inflamación, Insomnio,
          Acné Y Colesterol...{' '}
          <span className="bg-[#D4A017]/20 px-2 rounded inline-block transform -rotate-1" data-id="element-101">
            Antes De 48 Horas
          </span>
          "
        </h1>

        {/* Product Cover Image — moved below headline */}
        <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="mb-5" data-id="element-102">
          <img src="https://cdn.magicpatterns.com/uploads/fABC4s9ZQS4rk9zx9u7RM3/cover.png" alt="Tu Botiquín Natural 30+ Completo - eBook" className="mx-auto w-48 rounded-2xl shadow-2xl border-4 border-white/80" data-id="element-103" />
        </motion.div>

        {/* Layer 3: Sub-Headline */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.4
      }} className="bg-white border-l-4 border-[#2D5016] p-3 md:p-4 text-left md:text-center rounded-r-lg mx-auto max-w-2xl shadow-md mb-5" data-id="element-104">
          <p className="text-lg md:text-xl text-[#2D5016] font-medium leading-relaxed mb-2" data-id="element-105">
            Sin pastillas. Sin efectos secundarios. Sin salir de tu cocina.
          </p>
          <p className="text-lg md:text-xl text-[#2C1810] font-medium leading-relaxed" data-id="element-106">
            Con lo que encuentras hoy en tu mercado local por menos de $10.
          </p>
        </motion.div>

        {/* Micro-Bullets */}
        <div className="max-w-xl mx-auto text-left mb-6 space-y-2" data-id="element-107">
          {bullets.map((bullet, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.5 + i * 0.1
        }} className="flex items-start gap-3" data-id="element-108">
              <div className="bg-[#2D5016] rounded-full p-1 mt-1 flex-shrink-0" data-id="element-109">
                <Check className="w-3 h-3 text-white" data-id="element-110" />
              </div>
              <p className="text-[#2C1810] text-lg" data-id="element-111">
                <span className="font-bold" data-id="element-112">{bullet.bold}</span> {bullet.text}
              </p>
            </motion.div>)}
        </div>

        {/* CTA Button */}
        <div className="max-w-xl mx-auto mb-6" data-id="element-113">
          <CTAButton mainText="SÍ, QUIERO MIS RECETAS AHORA — $6.97" subText="Descarga instantánea · Garantía 30 días · Alivio en 48h" className="transform scale-105" data-id="element-114" />
        </div>

        {/* Trust Badges Row */}
        <div className="flex flex-wrap justify-center gap-3 md:gap-6 mb-4 text-xs md:text-sm font-semibold text-[#2C1810]/80" data-id="element-115">
          <div className="flex items-center gap-1 bg-white px-3 py-1.5 rounded-full shadow-sm border border-gray-100" data-id="element-116">
            <ShieldCheck className="w-4 h-4 text-[#2D5016]" data-id="element-117" />
            <span data-id="element-118">30 Días Garantía</span>
          </div>
          <div className="flex items-center gap-1 bg-white px-3 py-1.5 rounded-full shadow-sm border border-gray-100" data-id="element-119">
            <Download className="w-4 h-4 text-[#C1440E]" data-id="element-120" />
            <span data-id="element-121">Descarga Inmediata</span>
          </div>
          <div className="flex items-center gap-1 bg-white px-3 py-1.5 rounded-full shadow-sm border border-gray-100" data-id="element-122">
            <Lock className="w-4 h-4 text-[#D4A017]" data-id="element-123" />
            <span data-id="element-124">Pago Seguro</span>
          </div>
          <div className="flex items-center gap-1 bg-white px-3 py-1.5 rounded-full shadow-sm border border-gray-100" data-id="element-125">
            <Users className="w-4 h-4 text-[#2D5016]" data-id="element-126" />
            <span data-id="element-127">+{count.toLocaleString()} Familias</span>
          </div>
        </div>

        {/* Animated Counter Text */}
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1
      }} className="text-sm text-[#2C1810]/60 font-medium mb-2" data-id="element-128">
          🔥{' '}
          <span className="font-bold text-[#C1440E]" data-id="element-129">
            {count.toLocaleString()}+
          </span>{' '}
          familias ya confían en este botiquín
        </motion.p>
      </Section>
    </div>;
}